import React, {Component} from 'react';

import styles from './NumberedItem.css';

export default class NumberedItem extends Component {
    render() {
        const {number, title, content} = this.props;

        return (
            <li className={styles.wrapper}>
                <span className={styles.number}>{number}</span>
                <div className={styles.contentWrapper}>
                    <b>{title}</b>
                    {content}
                </div>
            </li>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/NumberedItem/NumberedItem.js